import React, { useEffect, useState } from 'react';

import _ from 'lodash';

import {
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  makeStyles,
  OutlinedInput,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import requestEndpoints from 'app/api/services/requestEndpoints';
import SaveButton from 'app/components/SaveButton';
import helpers from 'app/utils/helpers';
import moment from 'moment';
import SearchIcon from '@material-ui/icons/Search';

import notification from 'app/config/notification';
import { injectIntl } from 'react-intl';
import { STATUS_CODES } from 'app/config/status';

import styles from './styles';
const useStyles = makeStyles(styles);

const RequestData = props => {
  const { classes, request } = props;
  const jsonSolicitacao = request.jsonSolicitacao ? JSON.parse(request.jsonSolicitacao) : {};
  const document = jsonSolicitacao.cdTipoPessoaFisica
    ? jsonSolicitacao.deCpf || ''
    : jsonSolicitacao.deCnpjMatriz || jsonSolicitacao.deCpfCnpj || '';
  const name = jsonSolicitacao.cdTipoPessoaFisica
    ? jsonSolicitacao.nmCompleto || ''
    : jsonSolicitacao.deRazaoSocial ||
      jsonSolicitacao.nmCompleto ||
      jsonSolicitacao.nmUsuario ||
      '';
  return (
    <Grid container spacing={0} className={classes.requestResult}>
      <Grid item xs={12} sm={6}>
        <b>Solicitação {request.nuSolicitacaoFmt}</b>
      </Grid>
      <Grid item xs={12} sm={6}>
        Data solicitação: {moment.utc(request.dtCadastro).format('DD/MM/YYYY')}
      </Grid>
      <Grid item xs={12}>
        Empresa: {name}
      </Grid>
      <Grid item xs={12}>
        CNPJ: {helpers.formatarDocumento(document)}
      </Grid>
    </Grid>
  );
};

const Search = props => {
  const classes = useStyles();
  const {
    intl,
    openDrawer,
    onCloseDrawer,
    handleSelectSurvey,
    contextProps: { isInternalForm, canEdit, mainColor },
  } = props;

  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState(null);
  const [requests, setRequests] = useState([]);

  const handleChange = event => {
    setValue(event.target.value);
  };

  const handleSearch = async v => {
    setLoading(true);
    try {
      const search = {
        txtBusca: v,
        page: 0,
        situacoes: [{ cdSituacao: STATUS_CODES.AGUARDANDO_VISTORIA }],
      };
      const response = await requestEndpoints.getRequests(search);
      if (response?.status === 200 && response.data) {
        setRequests(response.data);
      }
    } catch (error) {}
    setLoading(false);
  };

  useEffect(() => {
    if (openDrawer) {
      handleSearch('');
    }
  }, [openDrawer]);

  return (
    <Grid container spacing={3} className={classes.containerForm}>
      <Grid item xs={12}>
        <FormControl fullWidth variant="outlined">
          <InputLabel htmlFor="outlined-adornment-search">
            Digite o Nº Solicitação, ou CNPJ ou Nome da empresa
          </InputLabel>
          <OutlinedInput
            id="outlined-adornment-search"
            value={search}
            onChange={e => setSearch(e.target.value)}
            onBlur={e => handleSearch(e.target.value)}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => {}}
                  onMouseDown={() => {}}
                  edge="end"
                >
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            }
            labelWidth={400}
          />
        </FormControl>
      </Grid>

      {loading && (
        <Grid item xs={12} className={classes.centerProgress}>
          <CircularProgress size={18} />
        </Grid>
      )}

      {!loading && (
        <Grid item xs={12}>
          <FormControl fullWidth component="fieldset">
            <RadioGroup aria-label="gender" name="gender1" value={value} onChange={handleChange}>
              {requests.content && (
                <>
                  {requests.content.length > 0 ? (
                    requests.content.map((r, i) => {
                      return (
                        <FormControlLabel
                          key={`req-${i}`}
                          className={classes.radio}
                          value={String(r.cdSolicitacao)}
                          control={<Radio />}
                          label={<RequestData request={r} classes={classes} />}
                        />
                      );
                    })
                  ) : (
                    <Grid item xs={12} className={classes.noResults}>
                      Nenhuma solicitação encontrada
                    </Grid>
                  )}
                </>
              )}
            </RadioGroup>
          </FormControl>
        </Grid>
      )}
      <SaveButton
        mainColor={mainColor}
        hideActionBtn={false}
        isInternalForm={isInternalForm}
        canEdit={canEdit}
        onCancel={() => {
          onCloseDrawer();
        }}
        onSave={() => {
          if (requests.content) {
            const found = _.find(requests.content, ['cdSolicitacao', Number(value)]);
            if (found) {
              onCloseDrawer();
              handleSelectSurvey(found);
            } else {
              notification(
                intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.NO_REQUEST_SELECTED' }),
                { toastId: 'NO_REQUEST_SELECTED', type: 'warning' }
              );
            }
          }
        }}
        cancelLabel={'Voltar'}
        saveLabel={'Confirmar'}
      />
    </Grid>
  );
};

export default injectIntl(Search);
